import { api } from "../../../api/apiSlice";

// Branch-wise master (revised 2026-08-13, superseding the original
// global/shared build from the day before) - the API session backfilled the
// real legacy area_master data (80 rows, per-branch, same overlapping
// numbering as empId/custId/productCode - e.g. areaId 2 is "TOWN" in
// Mombasa AND "TOWN" in TexasTrack) and switched every route to the
// {branchId}/{areaId} composite-key shape, matching Customer/Product/
// Employee. Confirmed live before rewiring: GET supports an optional
// ?branchId= filter, POST body now requires branchId, GET/PUT/DELETE are
// all keyed by {branchId}/{areaId}. Caught because an unfiltered
// getAreas() was showing every branch's areas mixed together in dropdowns -
// same area name appearing 2-4 times over (e.g. "TOWN" x3).
export const areasApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAreas: builder.query({
      query: (params) => ({ url: "/masters/areas", params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((a) => ({ type: "HrAreas", id: `${a.branchId}-${a.areaId}` })),
              { type: "HrAreas", id: "LIST" },
            ]
          : [{ type: "HrAreas", id: "LIST" }],
    }),
    createArea: builder.mutation({
      query: (body) => ({ url: "/masters/areas", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
    updateArea: builder.mutation({
      query: ({ branchId, areaId, ...body }) => ({
        url: `/masters/areas/${branchId}/${areaId}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
    deleteArea: builder.mutation({
      query: ({ branchId, areaId }) => ({
        url: `/masters/areas/${branchId}/${areaId}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "HrAreas", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetAreasQuery,
  useCreateAreaMutation,
  useUpdateAreaMutation,
  useDeleteAreaMutation,
} = areasApi;
